import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const menuItems = [
    { id: 'company', label: '소개' },
    { id: 'artist', label: '작가' },
    { id: 'services', label: '서비스' },
    { id: 'reviews', label: '후기' },
    { id: 'location', label: '오시는 길' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled ? 'bg-white/95 backdrop-blur-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20 lg:h-24">
            {/* Logo */}
            <button
              onClick={() => scrollToSection('hero')}
              className="cursor-pointer"
            >
              <span className={`text-lg font-medium tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-black' : 'text-white'
              }`}>
                모래요정 K-Star 샌드아트
              </span>
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-12">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`text-sm font-light tracking-wider uppercase transition-colors duration-300 cursor-pointer hover:opacity-60 ${
                    isScrolled ? 'text-black' : 'text-white'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav>

            {/* CTA Button */}
            <button
              onClick={() => scrollToSection('contact')}
              className={`hidden lg:block px-6 py-2.5 text-xs font-medium tracking-wider uppercase transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isScrolled 
                  ? 'bg-black text-white hover:bg-black/80' 
                  : 'bg-white text-black hover:bg-white/90'
              }`}
            >
              문의하기
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
                isScrolled ? 'text-black' : 'text-white'
              }`}
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white">
            <nav className="px-6 py-8 space-y-6">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block w-full text-left text-sm font-light tracking-wider uppercase text-black hover:text-primary transition-colors cursor-pointer"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left text-sm font-light tracking-wider uppercase text-primary cursor-pointer"
              >
                문의하기
              </button>
            </nav>
          </div>
        )}
      </header>

      {/* Mobile Fixed Bottom Bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-lineGray">
        <div className="grid grid-cols-2">
          <a
            href="tel:010-5529-0122"
            className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-black border-r border-lineGray cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            전화
          </a>
          <button
            onClick={() => scrollToSection('contact')}
            className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-primary cursor-pointer"
          >
            <i className="ri-message-3-line"></i>
            상담
          </button>
        </div>
      </div>
    </>
  );
}
